export { knowYourRightsMenu, topMenu, productsMenu, companyMenu, supportMenu, legalMenu, imprintMenu } from "./menus";

export type { MenuProps } from "./menus.d";
